/* eslint-disable no-unused-vars */
import { useInfiniteQuery } from 'react-query'

import { getStoryViewersUsersList } from 'services/endpoints/story'
import { type SortDirection } from 'types/enums'

export const useGetStoryViewersUsers = (
    storyId: string,
    sortDirection: SortDirection,
    searchTerm: string
) => {
    return useInfiniteQuery(
        ['storyViewers', storyId, sortDirection, searchTerm],
        async ({ pageParam = 1 }) =>
            // eslint-disable-next-line @typescript-eslint/return-await
            await getStoryViewersUsersList(
                storyId,
                sortDirection,
                pageParam,
                searchTerm
            ),
        {
            getNextPageParam: lastPage => {
                if (
                    lastPage?.data?.pagination?.current_page *
                        lastPage?.data?.pagination?.per_page <=
                    lastPage?.data?.pagination?.total
                ) {
                    return lastPage?.data?.pagination?.current_page + 1
                } else return false
            },
            refetchOnWindowFocus: false,
            staleTime: 10000
        }
    )
}
